import { CommonModule } from "@angular/common";
import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { QRCodeModule } from "angularx-qrcode";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";

@Component({
  selector: "app-generic-barcode-scan-dialog",
  templateUrl: "./generic-barcode-scan-dialog.component.html",
  styleUrls: ["./generic-barcode-scan-dialog.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatDividerModule,
    QRCodeModule,
  ]
})
export class GenericBarcodeScanDialogComponent implements OnInit {
  @ViewChild('scanInput') scanInput!: ElementRef<HTMLInputElement>;
  scanValue = '';

  constructor(
    public dialogRef: MatDialogRef<GenericBarcodeScanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.scanInput.nativeElement.focus();
  }

  scanSuccessHandler(data: string) {
    this.close(data);
  }

  close(result: string) {
    this.dialogRef.close(result);
  }
}
